import jwt from 'jwt-decode';
import { JWT_MEMBER_NUMBER_KEY } from '@/config';

const token = (): string => localStorage.getItem('session-token') || '';

export const getMemberNumber = (): string => {
  try {
    const data = jwt(token() as string) as any;
    return data ? (data[JWT_MEMBER_NUMBER_KEY] as string) : '';
  } catch (error) {
    return '';
  }
};

export const isLogged = () => {
  return !!getMemberNumber();
};

export default token;
